import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SchedaCoopSocialiFormValidators } from './validators/scheda-coop-sociali.form-validators';
import { SchedaCoopSocialiWarningsFormService } from './warnings/scheda-coop-sociali.warnings';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { SchedaCoopSocialiFormListeners } from './listeners/scheda-coop-sociali.form-listeners';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { formPaths } from '@shared/constants/form-paths.const';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { buildEntiConvFormArray } from './common/builders/scheda-coop-sociali-form-array.builder';

@Injectable()
export class SchedaCoopSocialiFormService extends BaseRevisioneFormService<SchedaCoopSocialiWarningsFormService> {
    isDisabled$: Observable<boolean>;

    constructor(protected warningService: SchedaCoopSocialiWarningsFormService, protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(warningService, undefined, datiIdentificativiService);
    }

    override get dependencyPaths(): Set<string> {
        return new Set([
            // Effettività base sociale (cross-section)
            `${formPaths.baseSociale}.my_UnitaSociUtil`,
            `${formPaths.baseSociale}.my_UnitaNonSociUtil`,
            `${formPaths.baseSociale}.my_SociFisCoopData`,
            `${formPaths.baseSociale}.my_SociGiuCoopData`,
            `${formPaths.baseSociale}.my_SociFisFinData`,
            `${formPaths.baseSociale}.my_SociGiuFinData`,
            `${formPaths.baseSociale}.my_SociSpecData`,
        ]);
    }

    override initListener(): void {
        new SchedaCoopSocialiFormListeners(this._form, this.store).setListeners();
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopSociali: this.fb.group({
                        my_CkDenom: '',
                        my_CkServSocioSanit: '',
                        my_CkAgricolo: '',
                        my_CkIndustr: '',
                        my_CkComm: '',
                        my_CkServiz: '',
                        my_CkPlurimo: '',
                        my_CkSociVolontari: '',
                        my_SociVolontari: '',
                        my_SociVolontariMaschi: '',
                        my_SociVolontariFemmine: '',
                        my_CkSezSociVolont: '',
                        my_PercentSociVolont: '',
                        my_CkSociAssicurati: '',
                        my_CkVolontRimborso: '',
                        my_MotiviRimborso: '',
                        my_CkSociSvantagg: '',
                        my_PercentPersSvantagg: '',
                        my_PersSvantagg: '',
                        my_EntiConv: this.fb.group({
                            my_ElEntiConv: this.fb.array([]),
                        }),
                        my_NumConvEnti: '',
                        my_CkIscrAlboCoopSoc: '',
                        my_MotiviIscriz: '',
                        my_CkCoopInquadrata: '',
                        my_CkAmmessiSociFinanz: '',
                        my_NCoopConsorzio: '',
                        my_CkConsorzConforme: '',
                        my_ElencoPersGiuridiche: '',
                        my_ScSocObbl: '',
                        my_DescEntiConvenzionati: '',
                        my_group36: '',
                        my_group37: '',
                        my_group38: '',
                        my_group40: '',
                        my_group41: '',
                        my_CkTrattasiDiConsorzio: '',
                        my_NormodotateA: '',
                        my_NormodotateB: '',
                        my_TotLavoratori: '',
                        my_SottocategoriaSezEnteSociale: '',
                        my_SottocategoriaSezEnteSocialeDesc: '',
                        my_MotivoAssenzaSottocategoriaSoc: '',
                        my_CkOnlus: '',
                        my_NoteOnlus: '',
                        my_MotiviSociSvantagg: '',
                        my_ckCoopSvolgeCommEqSolid: '',
                        my_ckAttSocEduPrevCommEqSolid: '',
                        my_ckCommEqSolidStrumAttSocEdu: '',
                        my_ckCommEqSolidDocumStrumAtt: '',
                    }),
                    my_EffettivitaBaseSociale: this.fb.group({
                        my_UnitaSociUtil: '',
                        my_UnitaNonSociUtil: '',
                        my_SociFisCoopData: '',
                        my_SociGiuCoopData: '',
                        my_SociFisFinData: '',
                        my_SociGiuFinData: '',
                        my_SociSpecData: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: SchedaCoopSocialiFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, 'my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_ScSocObbl');
    }

    protected override afterPopulateForm(myVerbale: MyVerbale): void {
        buildEntiConvFormArray(this.fb, myVerbale, this._form);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScSocObbl);
    }
}
